export const LAYER_TYPES = ["main", "persistent", "ephemeral"] as const;
